import styled from 'styled-components';

const StyledArrowButton = styled.button.attrs({ type: 'button' })`
  appearance: none;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  font-size: 1rem;
  padding: 9em 4.5em;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 1000;

  &:hover {
    svg {
      path {
        fill: ${({ theme }) => theme.genericColors.orangeSoft};
      }
      filter: ${({ theme }) => theme.themeColors.arrowButtons.dropShadow};
    }
  }

  &:focus {
    outline: 0;
  }

  &:active {
    svg {
      path {
        fill: ${({ theme }) => theme.genericColors.orangeMain};
      }
    }
  }
  @media all and (max-width: 1200px) {
    width: 50px;
    height: 50px;
    padding: 13px 15px;
    border-radius: 10px;
    background: #F4F4F4;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    & svg {
      width: 9px;
      height: 17px;
      path {
        stroke-width: 2px;
        fill: #4E4E4E;
      }
    }
  }
`;

export const StyledArrowLeftButton = styled(StyledArrowButton)`
  left: 20px;
`;

export const StyledArrowRightButton = styled(StyledArrowButton)`
  right: 20px;
`;
